import * as v from "valibot";

import { rpcContract } from "../rpc";

export const createWorldRpcContract = rpcContract({
  name: "createWorld",
  paramsSchema: v.object({
    name: v.pipe(
      v.string(),
      v.trim(),
      v.minLength(1, "World name is required"),
      v.maxLength(64, "World name cannot exceed 64 characters"),
    ),
    description: v.optional(v.pipe(v.string(), v.trim(), v.maxLength(500, "Description cannot exceed 500 characters"))),
    thumbnailFileId: v.optional(v.string()),
    postIds: v.optional(v.array(v.string())),
  }),
  resultSchema: v.object({
    id: v.string(),
    name: v.string(),
    description: v.nullable(v.string()),
    mediaUrl: v.nullable(v.string()),
    postCount: v.number(),
    status: v.union([v.literal("live"), v.literal("draft")]),
    createdAt: v.string(),
    updatedAt: v.string(),
  }),
});

export type CreateWorldParams = v.InferOutput<(typeof createWorldRpcContract)["paramsSchema"]>;
export type CreateWorldResult = v.InferOutput<(typeof createWorldRpcContract)["resultSchema"]>;
